/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLocationProducts200ResponseItemsInner
 */
export interface GetLocationProducts200ResponseItemsInner {
    /**
     * 
     * @type {string}
     * @memberof GetLocationProducts200ResponseItemsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocationProducts200ResponseItemsInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocationProducts200ResponseItemsInner
     */
    color: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetLocationProducts200ResponseItemsInner
     */
    enabled: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetLocationProducts200ResponseItemsInner
     */
    organizationEnabled: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetLocationProducts200ResponseItemsInner
     */
    printers: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetLocationProducts200ResponseItemsInner
     */
    course: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetLocationProducts200ResponseItemsInner
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof GetLocationProducts200ResponseItemsInner
     */
    copies: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetLocationProducts200ResponseItemsInner
     */
    modifierGroups: Array<string>;
}

/**
 * Check if a given object implements the GetLocationProducts200ResponseItemsInner interface.
 */
export function instanceOfGetLocationProducts200ResponseItemsInner(value: object): value is GetLocationProducts200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('color' in value) || value['color'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('organizationEnabled' in value) || value['organizationEnabled'] === undefined) return false;
    if (!('printers' in value) || value['printers'] === undefined) return false;
    if (!('course' in value) || value['course'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('copies' in value) || value['copies'] === undefined) return false;
    if (!('modifierGroups' in value) || value['modifierGroups'] === undefined) return false;
    return true;
}

export function GetLocationProducts200ResponseItemsInnerFromJSON(json: any): GetLocationProducts200ResponseItemsInner {
    return GetLocationProducts200ResponseItemsInnerFromJSONTyped(json, false);
}

export function GetLocationProducts200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLocationProducts200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'color': json['color'],
        'enabled': json['enabled'],
        'organizationEnabled': json['organizationEnabled'],
        'printers': json['printers'],
        'course': json['course'],
        'price': json['price'],
        'copies': json['copies'],
        'modifierGroups': json['modifierGroups'],
    };
}

export function GetLocationProducts200ResponseItemsInnerToJSON(json: any): GetLocationProducts200ResponseItemsInner {
    return GetLocationProducts200ResponseItemsInnerToJSONTyped(json, false);
}

export function GetLocationProducts200ResponseItemsInnerToJSONTyped(value?: GetLocationProducts200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'color': value['color'],
        'enabled': value['enabled'],
        'organizationEnabled': value['organizationEnabled'],
        'printers': value['printers'],
        'course': value['course'],
        'price': value['price'],
        'copies': value['copies'],
        'modifierGroups': value['modifierGroups'],
    };
}

